import { z } from 'zod'

const PHONE_REGEX = /^(0|\+84)(3[2-9]|5[25689]|7[06-9]|8[1-9]|9[0-9])\d{7}$/

export const addressSchema = z.object({
  fullName: z.string()
    .trim()
    .min(2, 'Họ tên tối thiểu 2 ký tự')
    .max(80, 'Họ tên tối đa 80 ký tự'),
  phone: z.string()
    .trim()
    .regex(PHONE_REGEX, 'Số điện thoại không hợp lệ (VD: 0912345678)'),
  email: z.string()
    .trim()
    .email('Email không hợp lệ'),
  province: z.string().min(1, 'Vui lòng chọn Tỉnh / Thành phố'),
  district: z.string().min(1, 'Vui lòng chọn Quận / Huyện'),
  ward: z.string().min(1, 'Vui lòng chọn Phường / Xã'),
  street: z.string().trim().min(5, 'Địa chỉ chi tiết tối thiểu 5 ký tự').max(200, 'Tối đa 200 ký tự'),
  note: z.string().max(300, 'Ghi chú tối đa 300 ký tự').optional().or(z.literal('')),
})

export type AddressFormValues = z.infer<typeof addressSchema>
